import { addLocaleData, IntlProvider } from 'react-intl';
import moment from 'moment';

const flattenMessages = (nestedMessages, prefix = '') =>
  Object.keys(nestedMessages).reduce((messages, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
  }, {});

const defaultLocalizationSettings = {
  locale: 'en-US',
  messages: {},
  modules: {},
};

const getLocale = () => {
  const { locale } = window.App
    ? window.App.localizationInfo || defaultLocalizationSettings
    : defaultLocalizationSettings;
  return locale.toLowerCase();
};

const getMessages = () => {
  const { messages, modules } = window.App
    ? window.App.localizationInfo || defaultLocalizationSettings
    : defaultLocalizationSettings;
  return {
    ...messages,
    ...flattenMessages(modules),
  };
};

const loadLocaleData = () => {
  const locale = getLocale();
  let languageCode = locale.split('-')[0];
  let localeData;

  try {
    localeData = require(`react-intl/locale-data/${languageCode}`);
  } catch (excep) {
    languageCode = 'en';
    localeData = require(`react-intl/locale-data/${languageCode}`);
  }

  addLocaleData([...localeData]);
  moment.locale(locale);
};

let intlProvider = null;
const getIntl = () => {
  if (intlProvider === null || intlProvider.props.locale !== getLocale()) {
    loadLocaleData();
    intlProvider = new IntlProvider({ locale: getLocale(), messages: getMessages() }, {});
  }
  return intlProvider.getChildContext().intl;
};

export { getLocale, getMessages, getIntl, loadLocaleData };



// WEBPACK FOOTER //
// ./src/Shared/CustomIntlProvider/localization.js